import { createHttpLink } from 'apollo-link-http'
import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'

import introspectionQueryResultData from '~/apollo/generated/types.json'

const GRAPHCMS_API = `${process.env.DEXTRA_WEBSITE_URL}/graphcms/master` // URL für CMS-Schnittstelle

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
})

export default ({ app }) => {
  const httpLink = createHttpLink({
    uri: GRAPHCMS_API,
  })

  const authLink = setContext((_, { headers }) => {
    const link = {
      headers: {
        ...headers,
        'gcms-locales': `${app.i18n.locale}, de`,
      },
    }

    return link
  })

  return {
    link: authLink.concat(httpLink),
    cache: new InMemoryCache({ fragmentMatcher }),
    defaultHttpLink: false,
  }
}
